module.exports = __webpack_public_path__ + "static/media/1f633.0bbb7bd1.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/twemoji/1f633.svg
 ** module id = 270
 ** module chunks = 0
 **/